<template>
  <header>
    <ul class="nav">
      <NavMenuItem
        v-for="navItem in navItems"
        :key="navItem.value"
        :label="navItem.name"
        :to="{ name: navItem.value }"
        :active="$route.name == navItem.value"
      />
    </ul>
    <div class="login-wrapper">
      <div class="actions">
        <div class="dark-mode action-item">
          <Light v-if="isDarkMode" :color="'rgb(255 255 255 / 60%)'" />
          <Dark v-else :color="'rgb(255 255 255 / 60%)'" />
        </div>
        <div
          class="action-item language-dropdown"
          :class="{ open: dropdownOpened }"
        >
          <Dropdown
            v-model="currentLanguage"
            v-model:open="dropdownOpened"
            :options="languageOptions"
          >
            <component v-if="selectedLanguageIcon" :is="selectedLanguageIcon" />
          </Dropdown>
        </div>
      </div>
      <div class="login">
        <Button
          v-if="!accessToken"
          @click="$store.commit('auth/SHOW_LOGIN_MODAL', true)"
          >Login</Button
        >
        <DotsLoader small v-else-if="accessToken && !user.id" />
        <div v-else class="logged-in-user">
          <img :src="user.avatar" :alt="user.name" />
          <Dropdown :options="userOptions">
            <span>{{ user.name }}</span>
          </Dropdown>
        </div>
      </div>
    </div>
    <LoginModal
      v-if="showLoginModal"
      @close="$store.commit('auth/SHOW_LOGIN_MODAL', false)"
      img="Welcome.png"
      name="Welcome"
    />
  </header>
</template>

<script lang="ts">
import { Component, defineComponent, shallowRef } from "vue"
import NavMenuItem from "./NavMenuItem.vue"
import {
  Dark,
  Light,
  English,
  Chinese,
  Russia,
  French,
  Spanish,
} from "@/components/icons/index"
import Dropdown, { DropdownOption } from "@/components/uikit/Dropdown.vue"
import Button from "@/components/uikit/Button.vue"
import { UserData } from "@/store/types"
import { mapActions } from "vuex"
import i18n from "@/translations/index"
import RobloxConnect from "@/services/RobloxConnect"
import DotsLoader from "../uikit/DotsLoader.vue"
import LoginModal from "@/components/login/desktop/index.vue"
export default defineComponent({
  name: "NavHeader",
  props: {},
  components: {
    Button,
    NavMenuItem,
    Dark,
    Light,
    English,
    Dropdown,
    Chinese,
    French,
    Spanish,
    DotsLoader,
    LoginModal,
  },
  data() {
    return {
      isDarkMode: true,
      navItems: [
        { name: "layout.nav.home", value: "home" },
        {
          name: "layout.nav.inventory",
          value: "inventory",
        },
        {
          name: "layout.nav.game_history",
          value: "game-history",
        },
        {
          name: "layout.nav.referral_program",
          value: "referral-program",
        },
        {
          name: "layout.nav.leaderboard",
          value: "leaderboard",
        },
      ],
      currentLanguage: "en",
      userOptions: [
        {
          label: "Logout",
          key: "logout",
          onClick: this.logout,
        },
      ] as DropdownOption[],
      languageOptions: [
        {
          label: "English",
          key: "en",
          icon: shallowRef(English),
        },
        {
          label: "Русский",
          key: "ru",
          icon: shallowRef(Russia),
        },
        // { label: "German", key: "ge", icon: shallowRef(German) },
        // { label: "Chinese", key: "ch", icon: shallowRef(Chinese) },
        // { label: "French", key: "fr", icon: shallowRef(French) },
        // { label: "Spanish", key: "sp", icon: shallowRef(Spanish) },
      ] as DropdownOption[],
      dropdownOpened: false,
      // showLoginModal: false,
    }
  },
  watch: {
    currentLanguage(newLanguage) {
      i18n.global.locale = newLanguage
    },
  },
  computed: {
    showLoginModal(): boolean {
      return this.$store.getters["auth/showLoginModal"]
    },
    accessToken(): string | null {
      return this.$store.state.auth.tokenData.access_token
    },
    user(): UserData {
      return this.$store.state.auth.user
    },
    selectedLanguageIcon(): Component | undefined {
      return this.languageOptions.find(
        (option: DropdownOption) => option.key === this.currentLanguage
      )?.icon
    },
  },
  methods: {
    connectRoblox: RobloxConnect.connectRoblox.bind(RobloxConnect),
    ...mapActions({
      logout: "auth/logout",
    }),
  },
  mounted() {
    if (this.user.is_admin) {
      this.userOptions.unshift({
        key: "admin-panel",
        label: "Admin Panel",
        onClick: () => this.$router.push("/admin"),
      })
    }
  },
})
</script>
<style scoped lang="scss">
header {
  // display: flex;
  // margin-left: var(--left-aside-width);
  // padding-left: 32px;
  // padding-right: 40px;
  // height: 67px;
  // border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  // justify-content: space-between;

  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  display: flex;
  padding-left: calc(var(--left-aside-width) + 32px);
  padding-right: 40px;
  height: 67px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  justify-content: space-between;
  box-sizing: border-box;
  background: #212429;
  z-index: 10;

  .nav {
    display: flex;
    gap: 40px;
  }

  .login-wrapper {
    align-items: center;
    display: flex;
    gap: 32px;
    .actions {
      gap: 24px;
      display: flex;
      .action-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        background: rgba(255, 255, 255, 0.04);
        border-radius: 12px;
        cursor: pointer;

        &.language-dropdown {
          &.open,
          &:hover {
            position: relative;
            &::after {
              pointer-events: none;
              content: "";
              position: absolute;
              inset: 0;
              border-radius: 12px;
              padding: 1px;
              background: var(--text-gradient);
              -webkit-mask: linear-gradient(#000 0 0) content-box,
                linear-gradient(#000 0 0);
              mask: linear-gradient(#000 0 0) content-box,
                linear-gradient(#000 0 0);
              -webkit-mask-composite: xor;
              mask-composite: exclude;
            }
          }
        }
      }
    }
  }
}
</style>
